var path = 'public/app/partials/dashboard.html';
var html = "<div dash-class ng-if=ctrl.dashboard>\n\t<dashnav dashboard=ctrl.dashboard></dashnav>\n\n\t<div class=\"scroll-canvas scroll-canvas--dashboard\" page-scrollbar>\n    <dashboard-settings dashboard=ctrl.dashboard ng-if=ctrl.dashboardViewState.state.editview class=dashboard-settings>\n    </dashboard-settings>\n\n    <div class=dashboard-container>\n      <dashboard-submenu ng-if=ctrl.dashboard.meta.submenuEnabled dashboard=ctrl.dashboard>\n      </dashboard-submenu>\n\n      <dashboard-grid get-panel-container=ctrl.getPanelContainer>\n      </dashboard-grid>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/partials/dashboard.html
// module id = 850
// module chunks = 2